import { Typography } from '@mui/material';

import { convertCo2Score } from '@/data/http/utils/convert-co2-score';
import { language, translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

type Co2Unit = 'kg' | 't';
type Size = 'normal' | 'large';

export function ScoreCo2Label({
  score,
  unit = 'kg',
  size = 'normal',
  scoreColor,
}: {
  score: number;
  unit?: Co2Unit;
  size?: Size;
  scoreColor?: string;
}) {
  const sizeSpecificStyle = getStyle(size);
  return (
    <Typography sx={sizeSpecificStyle}>
      <Typography
        component="span"
        sx={{
          ...sizeSpecificStyle,
          ...(scoreColor ? { color: scoreColor } : {}),
        }}
      >
        {formatScore(score, unit)}
      </Typography>
      <Typography component="span" sx={{ ...sizeSpecificStyle }}>
        {' '}
      </Typography>
      <Typography component="span" sx={{ ...sizeSpecificStyle }}>
        {formatLabel(unit)}
      </Typography>
    </Typography>
  );
}

function getStyle(size: Size) {
  switch (size) {
    case 'large':
      return { fontSize: '1.25rem', fontWeight: '900' };
    case 'normal':
      return { fontSize: '1rem', color: ColorsRaw.anthracite.Anthracite_5 };
  }
}

function formatScore(score: number, unit: Co2Unit): string {
  switch (unit) {
    case 'kg':
      return score.toLocaleString(language);
    case 't':
      return convertCo2Score(score).toLocaleString(language);
  }
}

function formatLabel(unit: Co2Unit): string {
  switch (unit) {
    case 'kg':
      return translate('Projects.kgeCO2');
    case 't':
      return translate('Projects.teCO2');
  }
}
